import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';
import { css, cx } from 'linaria';

const CustomBadgesContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  position: absolute;
  justify-content: space-between;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 6px 0;
  justify-content: ${({ placement }) =>
    placement === 'top' ? 'flex-start' : 'flex-end'};
  z-index: 1;
  pointer-events: none;
`;

const imageHeight = css`
  ${theme.above.lg} {
    height: 0;
    padding-top: calc(50% - 6px);
  }
`;

const CustomBadgesContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
`;

const CustomBadgeWrapper = styled('div')`
  height: 20px;
  width: auto;
  padding: 3px 8px;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 10px;
  font-family: ${theme.fonts.primaryFontFamily};
  font-weight: 700;
  letter-spacing: 1.2px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    width: auto;
  }

  /*Add more styles*/
  /**** END - CSS styles from admin ****/

  &.image {
    background: transparent;
    height: auto;
    width: auto;
    padding: 0;
  }
`;

const yellow = css`
  background: ${theme.colors.tags.yellow};
  color: black;
`;
const blue = css`
  background: ${theme.colors.tags.blue};
  color: black;
`;
const black = css`
  background: ${theme.colors.tags.black};
  color: white;
`;
const white = css`
  background: ${theme.colors.tags.white};
  color: black;
`;
const sale = css`
  background: ${theme.colors.tags.sale};
  color: white;
`;

export const CustomBadges = ({
  badges,
  placement = 'bottom',
  useImageHeight = false
}) => {
  function colorClassFromStyle(badge) {
    switch (badge.style) {
      case 'yellow':
        return yellow;
      case 'blue':
        return blue;
      case 'black':
        return black;
      case 'white':
        return white;
      case 'sale':
        return sale;
      default:
        return black;
    }
  }

  return (
    <CustomBadgesContainerWrapper
      placement={placement}
      className={cx(useImageHeight && placement === 'bottom' && imageHeight)}
    >
      <CustomBadgesContainer>
        {badges?.map((badge, index) =>
          badge.name.length > 0 || badge.text.length > 0 ? (
            <CustomBadgeWrapper
              key={index + '-' + badge.name}
              className={cx(colorClassFromStyle(badge))}
            >
              <p>{badge.text.length > 0 ? badge.text : badge.name}</p>
            </CustomBadgeWrapper>
          ) : null
        )}
      </CustomBadgesContainer>
    </CustomBadgesContainerWrapper>
  );
};
export default CustomBadges;
